module.exports = __webpack_public_path__ + "f8e1f8f5abf598a2bdc29c6e4ca2c23c.jpg";


//////////////////
// WEBPACK FOOTER
// ../~/file-loader!../loaders/scale-loader?size=410!./images/logos/JabJab-Cuisine-logo.jpg
// module id = 507
// module chunks = 0